import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import { AuthContext } from "../../Context/AuthContext";
function SideBar() {
  const [user] = useState({});
  const { role, permissions } = useContext(AuthContext) || {};
  const isAllowed = permission => role === 'Super Admin' || (permissions || []).some(item => item.name === permission);
  function toggle() {
    $("body").toggleClass("sidebar-toggled");
    $(".sidebar").toggleClass("toggled");
    if ($(".sidebar").hasClass("toggled")) {
      $(".sidebar .collapse").collapse("hide");
    }
  }
  return (
    <ul
      className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion "
      id="accordionSidebar"
    >
      <Link
        className="sidebar-brand d-flex align-items-center justify-content-center"
        to="/"
      >
        <div className="sidebar-brand-icon ">
          {user && user.logo ? (
            <img src={user.logo} height="50px" className="p-2"></img>
          ) : (
            <img src="/logo.svg" height="50px" className="p-2"></img>
          )}
        </div>
      </Link>
      <hr className="sidebar-divider my-0" />
      <li className="nav-item active">
        <Link className="nav-link" to="/">
          <i className="fas fa-fw fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </Link>
      </li>
      <hr className="sidebar-divider" />
      {isAllowed("list categories") ||
      isAllowed("list brands") ||
      isAllowed("list attributes") ||
      isAllowed("list attribute values") ||
      isAllowed("list attribute sets") ||
      isAllowed("list brand categories") ? (
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <i className="fa fa-bullhorn"></i>
            <span>Catalogs</span>
          </a>
          <div
            id="collapseOne"
            className="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionSidebar"
          >
            <div className=" py-2 collapse-inner rounded">
              {isAllowed("list categories") ? (
                <Link className="collapse-item" to="/categories">
                  Categories
                </Link>
              ) : (
                ""
              )}
              {isAllowed("list attributes") ? (
                <Link className="collapse-item" to="/attributes">
                  Attributes
                </Link>
              ) : (
                ""
              )}
              {isAllowed("list attribute values") ? (
                <Link className="collapse-item" to="/attribute-values">
                  Attribute Values
                </Link>
              ) : (
                ""
              )}
              {isAllowed("list attribute sets") ? (
                <Link className="collapse-item" to="/attribute-sets">
                  Attribute Sets
                </Link>
              ) : (
                ""
              )}
              {isAllowed("list brands") ? (
                <Link className="collapse-item" to="/brands">
                  Brands
                </Link>
              ) : (
                ""
              )}
              {isAllowed("list brand categories") ? (
                <Link className="collapse-item" to="/brand-categories">
                  Brand Categories
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
        </li>
      ) : (
        ""
      )}
      {isAllowed("list products") ? (
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="true"
            aria-controls="collapseTwo"
          >
            <i className="fa fa-box-open"></i>
            <span>Products</span>
          </a>
          <div
            id="collapseTwo"
            className="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordionSidebar"
          >
            <div className=" py-2 collapse-inner rounded">
              {isAllowed("list products") ? (
                <Link className="collapse-item" to="/products">
                  Products
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
        </li>
      ) : (
        ""
      )}
      {isAllowed("list services") ? (
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseThree"
            aria-expanded="true"
            aria-controls="collapseThree"
          >
            <i className="fa fa-sitemap"></i>
            <span>Services</span>
          </a>
          <div
            id="collapseThree"
            className="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordionSidebar"
          >
            <div className=" py-2 collapse-inner rounded">
              {isAllowed("list services") ? (
                <Link className="collapse-item" to="/services">
                  Services
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
        </li>
      ) : (
        ""
      )}
      {isAllowed("list users") ? (
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseFour"
            aria-expanded="true"
            aria-controls="collapseFour"
          >
            <i className="fa fa-users"></i>
            <span>User Management</span>
          </a>
          <div
            id="collapseFour"
            className="collapse"
            aria-labelledby="headingFour"
            data-parent="#accordionSidebar"
          >
            <div className=" py-2 collapse-inner rounded">
              <Link className="collapse-item" to="/users">
                Users
              </Link>
              <Link className="collapse-item" to="/roles">
                Roles
              </Link>
            </div>
          </div>
        </li>
      ) : (
        ""
      )}
      {isAllowed("list blog categories") || isAllowed("list blogs") ? (
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseSix"
            aria-expanded="true"
            aria-controls="collapseSix"
          >
            <i className="fa fa-copy"></i>
            <span>Cms </span>
          </a>
          <div
            id="collapseSix"
            className="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordionSidebar"
          >
            <div className=" py-2 collapse-inner rounded">
              {isAllowed("list blog categories") ? (
                <Link className="collapse-item" to="/blog_category">
                  Blog Category
                </Link>
              ) : (
                ""
              )}
              {isAllowed("list blogs") ? (
                <Link className="collapse-item" to="/blogs">
                  Blog list
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
        </li>
      ) : (
        ""
      )}
      {isAllowed("list product enquiries") || isAllowed("list enquiries") ? (
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseFive"
            aria-expanded="true"
            aria-controls="collapseFive"
          >
            <i className="fas fa-shopping-cart"></i>
            <span>Enquiries</span>
          </a>
          <div
            id="collapseFive"
            className="collapse"
            aria-labelledby="headingFive"
            data-parent="#accordionSidebar"
          >
            <div className=" py-2 collapse-inner rounded">
              {isAllowed("list enquiries") ? (
                <Link className="nav-link" to="/enquiries">
                  Service Enquiries
                </Link>
              ) : (
                ""
              )}
              {isAllowed("list product enquiries") ? (
                <Link className="nav-link" to="/product-enquiries">
                  Product Enquiries
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
        </li>
      ) : (
        ""
      )}
      {isAllowed("list logs") ? (
        <li className="nav-item ">
          <Link className="nav-link" to="/log">
            <i className="fas fa-fw fa-history"></i>
            <span>Logs</span>
          </Link>
        </li>
      ) : (
        ""
      )}
      <div className="text-center d-none d-md-inline">
        <button
          className="rounded-circle border-0"
          onClick={toggle}
          id="sidebarToggle"
        ></button>
      </div>
    </ul>
  );
}
export default SideBar;
